// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper-57Jfk";
var _4 = "inline-2Blsl";
var _5 = "header-1k3Rz";
var _6 = "header_content-1YIiH";
var _7 = "footer-yQL2G";
var _8 = "avatar-2lYWE";
var _9 = "info-1X7l0";
var _a = "name-1mmCp";
var _b = "notification-3xQrV";
var _c = "edit-3jAdv";
var _d = "edit__text-b_Mkd";
var _e = "companion-1gluk";
var _f = "empty-CEfOw";
var _10 = "button-vkO1c";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper", _4 as "inline", _5 as "header", _6 as "header_content", _7 as "footer", _8 as "avatar", _9 as "info", _a as "name", _b as "notification", _c as "edit", _d as "edit__text", _e as "companion", _f as "empty", _10 as "button" }
export default { "__esModule": _1, "mobile": _2, "wrapper": _3, "inline": _4, "header": _5, "header_content": _6, "footer": _7, "avatar": _8, "info": _9, "name": _a, "notification": _b, "edit": _c, "edit__text": _d, "companion": _e, "empty": _f, "button": _10 }
